import CloseIcon from "@mui/icons-material/Close";
import { Alert, IconButton, Snackbar } from "@mui/material";
import { useContext } from "react";

import { SimpleSnackbarContext } from "./Context";

const SimpleSnackbar = () => {
  const { store, actions } = useContext(SimpleSnackbarContext);
  return store.severity ? (
    <Snackbar
      open={store.isOpen}
      autoHideDuration={store.duration || 6000}
      onClose={actions.close}
    >
      <Alert elevation={6} variant="filled" severity={store.severity}>
        {store.message}
      </Alert>
    </Snackbar>
  ) : (
    <Snackbar
      open={store.isOpen}
      autoHideDuration={store.duration || 6000}
      onClose={actions.close}
      message={store.message}
      action={
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={actions.close}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  );
};

export default SimpleSnackbar;
